/**
 * Index Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('AuditLogIndexController', [
        '$scope',
        '$window',
        '$timeout',
        'seApi',
        function($scope, $window, $timeout, seApi) {
            $scope.data = log.data;
        },
    ]);
})(window.angular);
